module.exports = __webpack_public_path__ + "static/what-is-email-api-og-8dee4ef98e97aba64bac049db0b561b1.jpg";